import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerConfig {
  level: Number;
  toast: boolean;
}
